// import eight from "../../../src/assets/photos/grid/8.webp";
import nine from "../../../src/assets/photos/grid/9.webp";
import ten from "../../../src/assets/photos/grid/10.webp";
// import eleven from "../../../src/assets/photos/grid/11.webp";
import twelve from "../../../src/assets/photos/grid/12.webp";
import thirteen from "../../../src/assets/photos/grid/13.webp";
import two from "../../../src/assets/photos/grid/2.webp";


export default function ImageGrid() {
  const photos = [nine, ten, twelve];
  const photos2 = [thirteen, two];

  return (
    <div className="flex flex-col gap-5">
      <div className="grid grid-cols-1 sm:grid-cols-6 gap-5">
        {photos.map((src, index) => (
          <div
            key={index}
            className="flex justify-center rounded-xl w-full overflow-hidden transition-all duration-300 sm:col-span-2"
          >
            <img
              src={src}
              alt={`photo-${index}`}
              // width={238}
              // height={238}
              className="object-cover w-full"
            />
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-6 gap-5">
        {photos2.map((src, index) => (
          <div
            key={index}
            className={`flex justify-center rounded-xl w-full overflow-hidden transition-all duration-300 sm:col-span-2 ${
              index === 0 ? "sm:col-start-2" : "sm:col-start-4"
            }`}
          >
            <img
              src={src}
              alt={`photos2-${index}`}
              // width={238}
              // height={238}
              className="object-cover w-full"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
